<fieldset [formGroup]="skjema">
  <mat-radio-group formControlName="type" class="type">
    <mat-radio-button [value]="aksjeeiertypePerson">{{ "Privatperson" | translate }}</mat-radio-button>
    <mat-radio-button [value]="aksjeeiertypeOrganisasjon">{{ "Organisasjon" | translate }}</mat-radio-button>
  </mat-radio-group>

  <mat-form-field class="navn">
    <mat-label>{{ "Navn" | translate }}</mat-label>
    <input matInput formControlName="navn">
    @if(skjema.controls.navn.hasError('maxlength')){
      <mat-error data-testid="maxlength">{{skjema.controls.navn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
    }
    @if (duplikatAksjeeier()) {
      <mat-hint>
        <i class="icon ion-android-warning"></i>
        {{ "Det eksisterer allerede en aksjonær med samme navn" | translate }}
      </mat-hint>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ "E-post" | translate }}</mat-label>
    <input matInput type="email" formControlName="epost">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ "Adresse" | translate }}</mat-label>
    <textarea matInput formControlName="adresse" cdkTextareaAutosize cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"></textarea>
  </mat-form-field>
  @if (skjema.get('type').value === aksjeeiertypePerson) {
    <mat-form-field>
      <mat-label>{{ "Fødselsdato" | translate }}</mat-label>
      <input matInput [matDatepicker]="foedselsdatoVelger" formControlName="foedselsdato">
      <mat-datepicker-toggle matSuffix [for]="foedselsdatoVelger"/>
      <mat-datepicker #foedselsdatoVelger/>
      @if(skjema.controls.foedselsdato.hasError('matDatepickerParse')){
        <mat-error data-testid="matDatepickerParse">{{ skjema.controls.foedselsdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
      }
    </mat-form-field>
  } @else {
    <mat-form-field>
      <mat-label>{{ "Organisasjonsnummer" | translate }}</mat-label>
      <input matInput formControlName="organisasjonsnummer">
      @if(skjema.controls.organisasjonsnummer.hasError('maxlength')){
        <mat-error data-testid="maxlength">{{skjema.controls.organisasjonsnummer.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
      }
    </mat-form-field>
  }
  <tips>
    {{ 'Her kan du registrere hvem som skal representere denne aksjonæren/aksjeposten i generalforsamling.'|translate }}<br>
    {{ 'Velg gruppemedlemmet fra nedtrekkslisten eller opprett et nytt gruppemedlem.'|translate }}<br>
    {{ 'Merk at privatperson som er aksjonær også må være gruppemedlem.'|translate }}
  </tips>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label md-floating-label="always">{{ "Representert av" | translate }}</mat-label>
    <mat-select [formControl]="skjema.controls.representertAv" [compareWith]="erValgtMedlem"
                panelClass="medlemvelger--alternativer" data-testid="medlemvelger-felt">
      <mat-option [value]="null" class="ingen-valgt" data-testid="ingen-valgt" selected="">
        {{"Ingen valgt" | translate}}
      </mat-option>
      <mat-option [value]="{}" (onSelectionChange)="visNyInvitasjonSkjema($event)" class="legg-til-nytt" data-testid="legg-til-nytt-medlem-valg">
        {{ "Legg til nytt medlem" | translate }}
      </mat-option>
      @for (medlem of medlemmer; track medlem.id) {
      <mat-option [value]="medlem">
        <span class="navn">{{ medlem.navn }}</span> {{aktiveRolleMedParantesRundt(medlem)}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (skjema.value.erNyInvitasjon) {
    <div class="ny-invitasjon-kontainer">
      <div class="ramme-tittel">{{ "Ny invitasjon til gruppen" | translate }}</div>
      <medlem-invitasjon-skjema [skjema]="skjema.controls.nyInvitasjonSkjema" fokuserEpostFelt="true"/>
      <div class="rad-nederst">
        <mat-slide-toggle [formControl]="skjema.controls.sendInvitasjon" data-testid="send-invitasjonsepost"
                          matTooltip="{{'Skru av denne dersom du ikke ønsker at systemet sender en e-post med invitasjon'|translate}}">
          {{ 'Send invitasjons-e-post'|translate }}
        </mat-slide-toggle>
        <div class="avbryt">
          <a (click)="vedAvbrytNyMedlem()">{{ "Avbryt" | translate }}</a>
        </div>
      </div>
    </div>
  }

</fieldset>
